import React, { useCallback, useContext, useState } from 'react'
import {
  Button,
  Container,
  NavLink,
  Label,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  InputGroupText,
  InputGroup,
} from 'reactstrap'
import ReactLoading from 'react-loading'
import { Redirect, withRouter } from 'react-router-dom'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { toast } from 'react-toastify'

import WhiteFooter from 'components/Footers/WhiteFooter.js'
import logoMural from 'assets/img/logo_mural_2.png'
import { setToken } from 'services/auth'
import { UsersService } from 'services/users'
import ErrorText from 'components/Texts/ErrorText'
import { isAuthenticated } from 'services/auth'
import AuthContext from 'contexts/Auth'

const schema = yup.object().shape({
  Email: yup
    .string()
    .email('Informe um e-mail válido')
    .max(50, 'Limite máximo é de 50 caracteres')
    .required('Por favor, informe seu e-mail')
    .nullable(),
  Senha: yup
    .string()
    .required('Por favor, informe sua senha')
    .min(6, 'Limite mínimo é de 6 caracteres')
    .max(15, 'Limite máximo é de 15 caracteres')
    .nullable(),
})

const LoginPage = ({ history }) => {
  const { $user } = useContext(AuthContext)
  const { errors, register, handleSubmit } = useForm({ resolver: yupResolver(schema) })
  const { executeRecaptcha } = useGoogleReCaptcha()

  const [isLoading, setIsLoading] = useState(false)

  const onSubmit = useCallback(
    async (value) => {
      setIsLoading(true)

      const Captcha = await executeRecaptcha('login_pagina')

      try {
        const response = await UsersService.login({
          Login: value.Email,
          Senha: value.Senha,
          ManterConectado: value.ManterConectado,
          Captcha,
        })

        if (response.status === 200) {
          const token = response.data

          setToken(token)

          await $user()

          history.push('/mural-aprovados-sisu')
        }
      } catch (err) {
        toast.error('Houve um problema com o login, verifique suas credenciais.')
      } finally {
        setIsLoading(false)
      }
    },
    [executeRecaptcha, history, $user]
  )

  const goBack = useCallback(() => {
    history.push('/')
  }, [history])

  if (isAuthenticated()) {
    return <Redirect to="/mural-aprovados-sisu" />
  }

  return (
    <div className="section">
      <Container className="text-center">
        <Row>
          <Col style={{ textAlign: 'end' }}>
            <Button onClick={goBack} className="btn-round" color="#000">
              <span>X</span>
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <img src={logoMural} style={{ width: 260 }} alt="" />
          </Col>
        </Row>
        <Row>
          <Col className="ml-auto mr-auto text-center" md="12">
            <p
              className="description"
              style={{
                fontWeight: 400,
                color: '#000',
                letterSpacing: 2,
                lineHeight: 1.6,
                marginTop: 30,
              }}
            >
              Entrar no <span style={{ fontWeight: 600 }}>Mural de Aprovados SiSU</span> Evolucional.
            </p>
          </Col>
        </Row>
      </Container>

      <Container className="text-center" style={{ marginTop: 30, marginBottom: 30 }}>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="title-brand" style={{ marginTop: 15 }}>
            <InputGroup>
              <InputGroupText
                style={{
                  borderRadius: 20,
                  marginRight: 10,
                  height: 45,
                  paddingLeft: 19,
                  paddingRight: 20,
                }}
              >
                <i className="nc-icon nc-email-85" />
              </InputGroupText>

              <Input
                innerRef={register}
                id="Email"
                name="Email"
                placeholder="E-mail"
                type="text"
                style={{
                  borderRadius: 20,
                  height: 45,
                  paddingLeft: 20,
                  letterSpacing: 3,
                }}
              />
            </InputGroup>
            <ErrorText errors={errors} name="Email" />
          </div>

          <div className="title-brand" style={{ marginTop: 15 }}>
            <InputGroup>
              <InputGroupText
                style={{
                  borderRadius: 20,
                  marginRight: 10,
                  height: 45,
                  paddingLeft: 19,
                  paddingRight: 20,
                }}
              >
                <i className="nc-icon nc-lock-circle-open" />
              </InputGroupText>

              <Input
                innerRef={register}
                type="password"
                id="Senha"
                name="Senha"
                placeholder="Senha"
                autoComplete="off"
                style={{
                  borderRadius: 20,
                  height: 45,
                  paddingLeft: 20,
                  letterSpacing: 3,
                }}
              />
            </InputGroup>
            <ErrorText errors={errors} name="Senha" />
          </div>
          <div className="title-brand" style={{ marginTop: 12, letterSpacing: 4, marginBottom: 0 }}>
            {!isLoading ? (
              <Button
                className="btn-round"
                type="submit"
                style={{
                  fontSize: 14,
                  letterSpacing: 4,
                  textTransform: 'none',
                  backgroundColor: '#16057C',
                  color: '#FFF',
                  border: 0,
                  width: '100%',
                  height: 45,
                  borderRadius: 20,
                }}
              >
                Entrar
              </Button>
            ) : (
              <div align="center">
                <ReactLoading type={'bars'} color={'#16057C'} />
              </div>
            )}
            <br />
            {isLoading.error && <p style={{ marginTop: 20, color: '#E94B4B', fontWeight: 400 }}>{isLoading.error}</p>}
          </div>
        </Form>
      </Container>
      <div className="title-brand">
        <Row>
          <Col
            style={{
              textAlign: 'left',
              fontWeight: 400,
              letterSpacing: 2,
              color: '#000',
            }}
          >
            <FormGroup check>
              <Label check>
                <Input type="checkbox" id="ManterConectado" name="ManterConectado" innerRef={register} /> Manter-me
                conectado.
                <span className="form-check-sign">
                  <span className="check"></span>
                </span>
              </Label>
            </FormGroup>
          </Col>
          <Col style={{ textAlign: 'end', marginTop: -4 }}>
            <NavLink
              href="#!"
              onClick={() => history.push('/esqueci-minha-senha')}
              style={{
                color: '#000',
                fontSize: 14,
                fontWeight: 400,
                letterSpacing: 3,
              }}
            >
              Esqueci minha senha.
            </NavLink>
          </Col>
        </Row>
      </div>

      <hr />
      <div className="title-brand" style={{ marginBottom: 25, paddingTop: 10 }}>
        <Col style={{ textAlign: 'center' }}>
          <Button
            onClick={() => (window.location.href = '/#cadastro')}
            className="btn-round"
            color="danger"
            style={{
              letterSpacing: 1.5,
              paddingTop: 8,
              cursor: 'pointer',
              fontSize: 14,
              textTransform: 'none',
              fontWeight: 600,
            }}
          >
            Ainda não se cadastrou? Clique aqui.
          </Button>
        </Col>
      </div>
      <WhiteFooter />
    </div>
  )
}

export default withRouter(LoginPage)
